import './index.css';var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { defineComponent, ref, computed, watch, nextTick, onMounted, openBlock, createElementBlock, renderSlot, normalizeStyle, createElementVNode, onUnmounted, normalizeClass, normalizeProps, guardReactiveProps, createTextVNode, toDisplayString, createBlock, Fragment, renderList, withDirectives, vShow, createCommentVNode, mergeProps } from "vue";
import axios from "axios";
import { createI18n } from "vue-i18n";
const BootstrapVue = (options) => {
  const vueNodes = Array.from(document.querySelectorAll("[data-vue-instance]")) ?? [];
  const vueReplaceNodes = document.querySelectorAll("[data-vue-instance-replace]") ?? [];
  if (!vueNodes.length && !vueReplaceNodes.length) {
    return;
  }
  import("./vue-DfjoUqRl.js").then((module) => {
    for (const node of vueNodes) {
      module.createVue(node, options);
    }
    for (const node of vueReplaceNodes) {
      module.createVue(node, options, true);
    }
  });
};
const RunVueExtension = (options) => {
  BootstrapVue(options);
};
const RunAlpineExtension = (options = {}) => {
  import("./boot-TkWaiu5G.js").then((module) => module.startAlpine(options));
};
const RunIsotopeExtension = (options) => {
  import("./isotope-DwapzNEA.js").then((module) => module.BootstrapIsotope(options));
};
const RunMenuExtension = (options) => {
  import("./index-BpmdIyAd.js").then((module) => module.BootstrapMenu(options));
};
const RunToolsExtension = (options) => {
  import("./index-C1llzuKo.js").then((module) => module.BootstrapTools(options));
};
const RunThemeExtensions = (options) => {
  const { vue, alpine, isotope, menu, tools } = options;
  vue && RunVueExtension(vue);
  alpine && RunAlpineExtension(alpine);
  isotope && RunIsotopeExtension(isotope);
  menu && RunMenuExtension(menu);
  tools && RunToolsExtension(tools);
};
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "MasonryGrid",
  props: {
    watch: {
      type: Array,
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const grid = ref();
    const currentResizeObserverElements = ref([]);
    const gridResizeObserver = new ResizeObserver((items) => {
      items.forEach((item) => {
        resizeGridItem(item.target.parentElement);
      });
    });
    const allItems = () => {
      var _a;
      return Array.from(((_a = grid.value) == null ? void 0 : _a.children) ?? []);
    };
    const computedStyle = computed(() => window.getComputedStyle(grid.value));
    function resizeGridItem(item) {
      const gridRatio = parseInt(computedStyle.value.getPropertyValue("grid-auto-rows"));
      const rowGap = parseInt(computedStyle.value.getPropertyValue("--items-row-gap"));
      const innerItem = item.firstElementChild;
      const itemHeight = (innerItem == null ? void 0 : innerItem.getBoundingClientRect().height) ?? 0;
      const rowSpan = itemHeight + rowGap - gridRatio;
      item.style.gridRowEnd = "span " + Math.ceil(rowSpan / gridRatio);
    }
    function resizeAllGridItems() {
      allItems().forEach((item) => resizeGridItem(item));
    }
    function applyResizeObserver() {
      currentResizeObserverElements.value.forEach((item) => gridResizeObserver.unobserve(item));
      currentResizeObserverElements.value.splice(0, currentResizeObserverElements.value.length);
      const items = allItems().map((item) => item.firstElementChild);
      currentResizeObserverElements.value.push(...items);
      items.forEach((item) => {
        gridResizeObserver.unobserve(item);
        gridResizeObserver.observe(item, { box: "content-box" });
      });
    }
    props.watch && watch(
      props.watch,
      () => {
        nextTick(() => {
          applyResizeObserver();
          resizeAllGridItems();
        });
      },
      {
        immediate: true
      }
    );
    onMounted(() => {
      if (!props.watch) {
        nextTick(() => {
          applyResizeObserver();
          resizeAllGridItems();
        });
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "wte-masonry-grid",
        ref_key: "grid",
        ref: grid
      }, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 512);
    };
  }
});
const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const MasonryGrid = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["__scopeId", "data-v-439ce44e"]]);
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "InlineSpinner",
  props: {
    size: {
      type: Number,
      default: () => 20
    },
    stroke: {
      type: Number,
      default: () => 2
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "wte-inline-spinner",
        style: normalizeStyle({ "--wte-inline-spinner-size": __props.size + "px", "--wte-inline-spinner-stroke": __props.stroke + "px" })
      }, _cache[0] || (_cache[0] = [
        createElementVNode("span", { class: "loader" }, null, -1)
      ]), 4);
    };
  }
});
function debounce(callback, delay) {
  let timer;
  return (...args) => {
    return new Promise((resolve, reject) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        try {
          let output = callback(...args);
          resolve(output);
        } catch (err) {
          if (err instanceof Error) {
            reject(err);
          }
          reject(new Error(`An error has occurred:${err}`));
        }
      }, delay);
    });
  };
}
const _hoisted_1 = { class: "wte-dropdown-toggle-icon" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "wte-dropdown-option-checkbox" };
const _hoisted_4 = { class: "wte-dropdown-option-check-icon" };
const _hoisted_5 = { class: "wte-dropdown-option-label" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Dropdown",
  props: {
    modelValue: {
      type: Array
    },
    options: {
      type: Array,
      default: () => []
    },
    optionLabel: {
      type: String,
      default: () => "label"
    },
    optionValue: {
      type: String,
      default: () => "value"
    },
    optionDisabled: {
      type: String,
      default: () => "disabled"
    },
    showOptionCheckbox: {
      type: Boolean,
      default: () => false
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    placeholder: {
      type: String
    }
  },
  emits: ["update:modelValue", "change"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const el = ref();
    const optionsEl = ref();
    const optionsVisible = ref(false);
    const optionsPlacement = ref("below");
    const hideOptions = () => optionsVisible.value = false;
    const toggleOptions = () => optionsVisible.value = !optionsVisible.value;
    const isOptionSelected = (option) => {
      var _a;
      return (_a = props.modelValue) == null ? void 0 : _a.includes(getOptionValue(option));
    };
    const isOptionDisabled = (option) => {
      return option[props.optionDisabled];
    };
    const getOptionValue = (option) => {
      return option ? option[props.optionValue] : void 0;
    };
    const getOptionLabel = (option) => {
      return option ? option[props.optionLabel] : void 0;
    };
    const selectedOptions = computed(
      () => {
        var _a;
        return (((_a = props.modelValue) == null ? void 0 : _a.length) ?? 0) > 0 ? props.modelValue.map((v) => props.options.find((o) => getOptionValue(o) === v)) : void 0;
      }
    );
    const selectedLabels = computed(() => {
      var _a;
      return (_a = selectedOptions.value) == null ? void 0 : _a.map((o) => getOptionLabel(o));
    });
    const toggleLabel = computed(() => {
      var _a;
      return ((_a = selectedLabels.value) == null ? void 0 : _a.join(", ")) ?? props.placeholder;
    });
    const toggleOptionItem = (event, item) => {
      var _a;
      const value = item[props.optionValue] ?? void 0;
      if (!value) {
        return;
      }
      const output = {
        originalEvent: event,
        value: void 0
      };
      if ((_a = props.modelValue) == null ? void 0 : _a.includes(value)) {
        output.value = Array.from(new Set([...props.modelValue ?? []].filter((v) => v !== value)));
      } else {
        output.value = Array.from(/* @__PURE__ */ new Set([...props.modelValue ?? [], value]));
      }
      emit("update:modelValue", output.value);
      emit("change", output);
    };
    const outsideClickListener = (event) => {
      var _a;
      if (!((_a = el.value) == null ? void 0 : _a.contains(event == null ? void 0 : event.target))) {
        hideOptions();
      }
    };
    const optionsPlacementListener = () => {
      if (!optionsEl.value) {
        return;
      }
      const dropdownRect = el.value.getBoundingClientRect();
      const optionsRect = optionsEl.value.getBoundingClientRect();
      const distanceWindowBottom = window.innerHeight - dropdownRect.bottom - optionsRect.height;
      if (distanceWindowBottom < 10) {
        optionsPlacement.value = "above";
      } else {
        optionsPlacement.value = "below";
      }
    };
    const optionsPlacementListenerDebounced = debounce(optionsPlacementListener, 10);
    watch(optionsVisible, (value) => {
      if (value) {
        nextTick(optionsPlacementListener);
      }
    });
    onMounted(() => {
      window.addEventListener("click", outsideClickListener);
      window.addEventListener("scroll", optionsPlacementListenerDebounced);
    });
    onUnmounted(() => {
      window.removeEventListener("click", outsideClickListener);
      window.removeEventListener("scroll", optionsPlacementListenerDebounced);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["wte-dropdown", `wte-dropdown-options-placement-${optionsPlacement.value}`]),
        ref_key: "el",
        ref: el
      }, [
        renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({
          toggleOptions,
          optionsVisible: optionsVisible.value,
          placeholder: __props.placeholder,
          toggleLabel: toggleLabel.value,
          selectedLabels: selectedLabels.value,
          loading: __props.loading,
          options: __props.options,
          getOptionValue,
          getOptionLabel,
          isOptionSelected,
          isOptionDisabled,
          toggleOptionItem
        })), () => [
          createElementVNode("div", {
            class: normalizeClass(["wte-dropdown-toggle", { "wte-options-visible": optionsVisible.value }]),
            onClick: toggleOptions
          }, [
            createElementVNode("div", {
              class: normalizeClass(["wte-dropdown-toggle-label", { "is-placeholder": !!selectedLabels.value }])
            }, [
              renderSlot(_ctx.$slots, "toggle-label", normalizeProps(guardReactiveProps({ toggleLabel: toggleLabel.value, selectedLabels: selectedLabels.value, placeholder: __props.placeholder, selectedOptions: selectedOptions.value, options: __props.options })), () => [
                createTextVNode(toDisplayString(toggleLabel.value), 1)
              ])
            ], 2),
            createElementVNode("div", _hoisted_1, [
              __props.loading ? (openBlock(), createBlock(_sfc_main$1, { key: 0 })) : renderSlot(_ctx.$slots, "toggle-icon", { key: 1 }, () => [
                _cache[0] || (_cache[0] = createElementVNode("svg", {
                  width: "19",
                  height: "11",
                  viewBox: "0 0 19 11",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  createElementVNode("path", {
                    d: "M1.5 1.5L9.5 9.5L17.5 1.5",
                    stroke: "currentColor",
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1))
              ])
            ])
          ], 2),
          optionsVisible.value ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "wte-dropdown-options",
            ref_key: "optionsEl",
            ref: optionsEl
          }, [
            renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ options: __props.options, getOptionValue, getOptionLabel, isOptionSelected, isOptionDisabled, toggleOptionItem })), () => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(__props.options, (option) => {
                return openBlock(), createElementBlock("div", {
                  key: getOptionValue(option),
                  class: normalizeClass(["wte-dropdown-option-item", { selected: isOptionSelected(option), disabled: isOptionDisabled(option) }]),
                  onClick: ($event) => toggleOptionItem($event, option)
                }, [
                  __props.showOptionCheckbox ? renderSlot(_ctx.$slots, "option-checkbox", { key: 0 }, () => [
                    createElementVNode("div", _hoisted_3, [
                      withDirectives(createElementVNode("div", _hoisted_4, [
                        renderSlot(_ctx.$slots, "check-icon", {}, () => [
                          _cache[1] || (_cache[1] = createElementVNode("svg", {
                            width: "12",
                            height: "9",
                            viewBox: "0 0 12 9",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            createElementVNode("path", {
                              d: "M11 1L4.125 7.875L1 4.75",
                              stroke: "currentColor",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            })
                          ], -1))
                        ])
                      ], 512), [
                        [vShow, isOptionSelected(option)]
                      ])
                    ])
                  ]) : createCommentVNode("", true),
                  createElementVNode("div", _hoisted_5, [
                    renderSlot(_ctx.$slots, "option-label", mergeProps({ ref_for: true }, { option, getOptionLabel, getOptionValue, isOptionSelected, isOptionDisabled }), () => [
                      createTextVNode(toDisplayString(getOptionLabel(option)), 1)
                    ])
                  ])
                ], 10, _hoisted_2);
              }), 128))
            ])
          ], 512)) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});
let messages = {};
let i18n = null;
const makeI18nConfig = async (options) => {
  if (Object.keys(messages).length === 0) {
    const messagesRoute = (options == null ? void 0 : options.messagesRoute) ?? "/!/statamic-theme-extensions/lang.json";
    messages = (await axios.get(messagesRoute)).data;
  }
  return {
    messages,
    fallbackLocale: "en",
    locale: window.document.documentElement.lang ?? Object.keys(messages)[0] ?? "de",
    injectGlobal: true,
    legacy: false
  };
};
const makeI18n = async (options) => {
  const i18nConfig = await makeI18nConfig(options);
  i18n = createI18n(i18nConfig);
  return i18n;
};
const getVueI18n = () => {
  return i18n;
};
class AlpineComponent {
  constructor() {
    /** Retrieve the root component DOM node. */
    __publicField(this, "$el");
    /** Retrieve DOM elements marked with x-ref inside the component. */
    __publicField(this, "$refs");
    /** Retrieve the native browser "Event" object within an event listener. */
    __publicField(this, "$event");
    /** Create a CustomEvent and dispatch it using .dispatchEvent() internally. */
    __publicField(this, "$dispatch");
    /** Execute a given expression AFTER Alpine has made its reactive DOM updates. */
    __publicField(this, "$nextTick");
    /** Will fire a provided callback when a component property you "watched" gets changed. */
    __publicField(this, "$watch");
  }
}
function registerComponent(name, component, alpine) {
  if (component["prototype"] instanceof AlpineComponent) {
    component = convertClassToAlpineConstructor(component);
  }
  (alpine ?? window.Alpine).data(name, (...args) => component(...args));
  return component;
}
function convertClassToAlpineConstructor(component) {
  return function(...args) {
    let instance = new component(...args);
    const data = {};
    function extractPropsAndMethods(obj) {
      if (!obj) {
        return;
      }
      extractPropsAndMethods(Object.getPrototypeOf(obj));
      Object.getOwnPropertyNames(obj).forEach((prop) => {
        data[prop] = obj[prop];
      });
    }
    extractPropsAndMethods(instance);
    return data;
  };
}
function addTitles() {
  window.Alpine.onBeforeComponentInitialized((component) => {
    if (!component.$el.hasAttribute("x-title")) {
      if (component.$data.constructor.prototype instanceof AlpineComponent) {
        component.$el.setAttribute("x-title", component.$data.constructor.name);
      }
    }
  });
}
const callbacks = [];
document.addEventListener("DOMContentLoaded", () => {
  run();
});
document.addEventListener("readystatechange", (value) => {
  if (document.readyState === "complete") {
    run();
  }
});
const onReady = (callback) => {
  if (typeof callback !== "function") {
    throw Error("Callback must be function.");
  }
  callbacks.push(callback);
  if (document.readyState === "complete") {
    run();
  }
};
const run = () => {
  while (callbacks.length > 0) {
    callbacks.shift()();
  }
};
export {
  AlpineComponent as A,
  MasonryGrid as M,
  RunThemeExtensions as R,
  _sfc_main as _,
  _sfc_main$1 as a,
  RunAlpineExtension as b,
  convertClassToAlpineConstructor as c,
  addTitles as d,
  debounce as e,
  getVueI18n as g,
  makeI18n as m,
  onReady as o,
  registerComponent as r
};
//# sourceMappingURL=index-DuLt0Gnh.js.map
